import { Controller } from "stimulus";
import StimulusReflex from 'stimulus_reflex'
import Choices from 'choices.js';
import Clipboard from 'clipboard';


export default class extends Controller {
  static targets = ["telephoneDetails", "enableTelephoneBefriending", "videoDetails", "enableVideoBefriending", "form", "caller", "recipient", "videoButton"]

  connect() {
    StimulusReflex.register(this);
    super.connect();
    this.isSubmitting = false; // Add flag to track submission state
    this.initChoicesJS();
    this.initCallerChoicesJS();
    this.initFormValidation();
    this.validateForm();
    this.formTarget.addEventListener('submit', this.submitBefriendingMatch.bind(this));
    this.setupClipboard()
    this.fixCSRF()
  }

fixCSRF(){
  const oldCsrfToken = this.formTarget.querySelector('[name="authenticity_token"]').value;
  const newCsrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');
  //console.log(`Old CSRF Token: ${oldCsrfToken}, New CSRF Token: ${newCsrfToken}`);
  this.formTarget.querySelector('[name="authenticity_token"]').value = newCsrfToken;
}
// Initialises the calelr and recipient select dropdowns with Choices.js library for better UX and to add the camera icons etc
// Camera icons are added to all entries that have the hidden 200B unicode character in the label.

initCallerChoicesJS() {

  // Update the ARIA live region to empty
  const liveRegion = document.getElementById('aria-live-region');
  liveRegion.textContent = ``;

  var elements = document.querySelectorAll('.choices-caller');
  elements.forEach(element => {
    const choicesInstance = new Choices(element, {
      shouldSort: false,
      searchEnabled: true,
      allowHTML: true,
      itemSelectText: '', // Set to an empty string
    });

    // Get the dropdown element from Choices instance
    const dropdown = element.closest('.choices').querySelector('.choices__list--dropdown');

    // MutationObserver to observe changes in the dropdown
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('is-highlighted')) {
            // Log the highlighted item's text
            //console.warn(`Highlighted item: ${target.innerText}`);
            
            // Update the ARIA live region to announce the highlighted item
            const liveRegion = document.getElementById('aria-live-region');
            liveRegion.textContent = `Highlighted item: ${target.innerText}`;
          }
        }
      });
    });

    // Configuration for the observer: watch for attribute changes in dropdown items
    const config = { attributes: true, subtree: true, attributeFilter: ['class'] };
    observer.observe(dropdown, config);

    // Ensure to clean up the observer when the element is no longer needed
    element.addEventListener('disconnect', () => {
      observer.disconnect();
    });
  });
}

setupClipboard() {
  var notyf = new Notyf( {
    position: {
    x: 'right',
    y: 'top',
  }
});

  const clipboard = new Clipboard('.btnclipboard');  
  clipboard.on('success', (e) => {
    notyf.success('Copied to clipboard');
    e.clearSelection();
  });

  clipboard.on('error', (e) => {
    notyf.error('Failed to copy to clipboard');
  });
}

// Initialises the rest of the dropdowns with Choices.js library for better UX
initChoicesJS() {
  var elements = document.querySelectorAll('.choices-select');
  elements.forEach(element => {
    new Choices(element, {
      shouldSort: false,
      searchEnabled: true,
      itemSelectText: '', // Set to an empty string
    });
  });
}




  initFormValidation() {
    this.fv = FormValidation.formValidation(
      this.formTarget,
      {
        fields: {
          caller_id_select: {
            selector: '#caller_id_select',
            validators: {
              notEmpty: {
                message: 'The caller must be selected'
              }
            }
          },
          recipient_id_select: {
            selector: '#recipient_id_select',
            validators: {
              notEmpty: {
                message: 'The recipient must be selected'
              }
            }
          }
        },
        plugins: {
          trigger: new Trigger(
            {
              event: 'change'

            }
          )
        }
      }
    );

        // Add event listeners to each form field
      Array.from(this.formTarget.elements).forEach(element => {
        element.addEventListener('change', () => {
          this.fv.validate();
        });
      });

      // Listen to the 'core.form.valid' and 'core.form.invalid' events
      this.fv.on('core.form.valid', () => {
        document.getElementById('createBefriendingMatchSubmit').disabled = false;
      });

      this.fv.on('core.form.invalid', () => {
        document.getElementById('createBefriendingMatchSubmit').disabled = true;
      });
  }

  // Method to trigger form validation manually
  validateForm() {
    this.fv.validate().then((status) => {

      // You can add any additional logic you need to run after validation here
    });
  }

  submitBefriendingMatch(event) {
    event.preventDefault();
    
    // Prevent double submission
    if (this.isSubmitting) {
      console.log('Form submission already in progress, ignoring duplicate click');
      return false;
    }
    
    // Mark as submitting
    this.isSubmitting = true;
    
    // Get the submit button
    const submitBtn = document.getElementById('createBefriendingMatchSubmit');
    if (submitBtn) {
      const originalText = submitBtn.textContent;
      const originalHTML = submitBtn.innerHTML;
      
      // Store original state for potential restoration
      submitBtn.dataset.originalText = originalText;
      
      // Disable button and show loading state
      submitBtn.disabled = true;
      submitBtn.classList.add('submitting');
      
      // Add spinner and update text based on action
      const actionText = originalText.toLowerCase().includes('create') ? 'Creating...' : 
                        originalText.toLowerCase().includes('reactivate') ? 'Reactivating...' : 'Saving...';
      submitBtn.innerHTML = '<i class="bi bi-arrow-repeat busy d-inline-block me-1"></i>' + actionText;
    }
    
    // Submit the form
    this.formTarget.submit();
    
    // Note: We don't re-enable the button here as the page will redirect on success
    // Only on error would we need to re-enable, but that would require error handling
  }
  
}